export default __webpack_public_path__ + "static/OpenGround-TypoSymbol-e4897e09fb02bf86453730e1d43d1ab7.png";